export enum PricingProvider {
    BVALKanerai = "BVALKanerai",
    HoulihanLokey = "HoulihanLokey",
    IHSMarkit = "IHSMarkit",
    JPPricingDirect = "JPPricingDirect",
    L3Valuations = "L3Valuations",
    Mountainview = "Mountainview",
    PriceServeByBofa = "PriceServeByBofa",
    RefinitiveLSEG = "RefinitiveLSEG",
    Other = "Other",
}
